(function($) {
    function set_Position() {
        var container_offset = $('.two-col-list  .container').offset().left;
        var offset = $('.two-col-list  .column-wrapper .col-two:eq(1) p').offset().left;
        var total = offset - container_offset - 20;
        $('.two-col-list .link-more span').css('left', total + 'px');
    }

    $(document).ready(function() {

        if ($('.two-col-list').length > 0) {
            if (!$('.two-col-list').hasClass('html')) {
                set_Position();

            }
            $('.two-col-list .link-more > span').on('click', function() {
                $(this).parents('.row-wrap').find('.hide').slideToggle(600);
                $(this).toggleClass('less');
                if ($(this).hasClass('less')) {
                    $(this).text('View Less');
                } else {
                    $(this).text('View More');
                }
            });


            $('.two-col-list').each(function() {
                $('.two-col-list').addClass('border');
                $(this).last().removeClass('border');
            });


            $('.two-col-list.html .column-wrapper').each(function() {
                var len = $(this).find('li').length;
                var mid = len / 2;

                var item = $(this).find('.col-two li');
                item.slice(mid, len).addClass('right-col');

                if (len > 20) {
                    var fontSize = $(this).find('.col-two li').css('font-size');
                    fontSize = fontSize.replace(/[^0-9]/g, '');
                    var lineHeight = 2.11;
                    var divHeight = fontSize * lineHeight * 10;
                    if ($(window).width() >= 1200 && $(window).width() < 1366) {
                        divHeight *= 2;
                    }
                    divHeight = divHeight + 'px';

                    // var item=$(this).parents('.column-wrapper').find('.col-two p');
                    // item.slice(20,len);
                    $(this).append('<span class="link-more"><span>View More</span></span>');
                    $(this).find('.col-two').css('max-height', divHeight);
                }
            });
            $('.two-col-list .link-more').click(function() {
                $(this).siblings('.col-two').toggleClass('open');
            });



            $('.two-col-list.html .link-more span').on('click', function() {
                // var len=$(this).parents('.column-wrapper').find('.col-two p').length;
                // var item=$(this).parents('.column-wrapper').find('.col-two p');
                $(this).toggleClass('less');
                if ($(this).hasClass('less')) {
                    // setTimeout(function () {
                    $(this).text('View Less');
                    $(this).removeClass('more');
                    // }, 250);
                    // item.slice(20, len).show();
                } else {
                    // item.slice(20, len).hide();

                    $(this).text('View More');
                    $(this).addClass('more');
                }
            });
            $(document).on('click', '.two-col-list.html .link-more .more', function() {
                headerHeight = $(".two-col-list").offset().top - $("header").outerHeight();
                $("html, body").animate({
                        scrollTop: headerHeight,
                    },
                    600,
                    "linear"
                );
            });
        }
        $(".two-col-list.html li:nth-child(2)").removeClass("right-col");
    });

    $(window).on('resize orientationchange', function() {
        if ($('.two-col-list').length > 0) {
            if (!$('.two-col-list').hasClass('html')) {
                set_Position();
            }

            $('.two-col-list.html .column-wrapper').each(function() {
                var len = $(this).find('li').length;
                if (len > 20) {
                    var fontSize = $(this).css('font-size');
                    fontSize = fontSize.replace(/[^0-9]/g, '');
                    var lineHeight = 2.11;
                    var divHeight = fontSize * lineHeight * 10;
                    if ($(window).width() >= 1200 && $(window).width() < 1366) {
                        divHeight *= 2;
                    }
                    divHeight = divHeight + 'px';


                    $(this).find('.col-two').css('max-height', divHeight);
                }
            });

        }
    });

})(jQuery);